import React from 'react';
import { QuestionOption } from '../../../config/surveys/schema';
import { EMOJI_SCALE } from '../../../config/surveys/defaults';
import './EmojiScaleQuestion.css';

interface EmojiScaleQuestionProps {
  questionId: string;
  value: string | undefined;
  onChange: (value: string) => void;
  options?: QuestionOption[];
}

const EmojiScaleQuestion: React.FC<EmojiScaleQuestionProps> = ({
  questionId,
  value,
  onChange,
  options = EMOJI_SCALE,
}) => {
  return (
    <div className="emoji-scale-options">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`emoji-option ${value === option.value ? 'selected' : ''}`}
          onClick={() => onChange(option.value)}
          aria-pressed={value === option.value}
          aria-label={option.label}
        >
          <span className="emoji" role="img" aria-hidden="true">
            {option.emoji}
          </span>
          <span className="emoji-label">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default EmojiScaleQuestion;
